import React, { Component } from 'react'

import { Button, Grid, InputAdornment } from '@mui/material'

import { campaignStatusesMap } from '@albacross/frontend-utils'

import CustomerSelect from 'components/customer/CustomerSelect'
import { FormDatePicker, FormSelect, FormTextField } from 'components/input'
import { DescriptionListTable } from 'components/table'
import { withForm } from 'decorators/withForm'
import { useCampaignDerivedFields } from 'hooks/useCampaignDerivedFields'
import { assignableUsersOptions } from 'models/campaign-model'
import { CPM_OPTIONS } from 'models/campaign-review-model'
import { campaignChangedCustomerWarnings, campaignEditValidator } from 'validators/campaign-edit'

const FORM_NAME = 'campaignEdit'

const statusOptions = [...campaignStatusesMap].map(([value, label]) => ({ value, label }))

type EditFormProps = {
  handleSubmit: (...args: any[]) => any
  initialValues: Record<string, any>
  loading: boolean
  onSubmit: (...args: any[]) => any
}

class EditForm extends Component<EditFormProps> {
  getConfig = (p = this.props) => [
    {
      title: 'Campaign Name',
      render: () => <FormTextField name="title" />,
    },
    {
      title: 'Customer',
      render: () => <CustomerSelect name="customer" />,
    },
    {
      title: 'Landing page URL',
      render: () => <FormTextField name="url" />,
    },
    {
      title: 'Start date',
      render: () => <FormDatePicker disabled={p.initialValues.status !== 'accepted'} name="startDate" />,
    },
    {
      title: 'End date',
      render: () => <FormDatePicker name="endDate" />,
    },
    {
      title: 'Currency',
      field: 'currency',
    },
    {
      title: 'Estimated Total Budget',
      render: () => <FormTextField name="totalBudget" type="number" />,
    },
    {
      title: 'Daily Budget',
      render: () => <FormTextField name="dailyBudget" type="number" />,
    },
    {
      title: 'CPM',
      render: () => <FormSelect name="cpm" options={CPM_OPTIONS} />,
    },
    {
      title: 'Goal impressions',
      render: () => <FormTextField name="goalImpressions" type="number" />,
    },
    {
      title: 'Goal RTB impressions',
      render: () => <FormTextField name="goalRtbImpressions" type="number" />,
    },
    {
      title: 'Extra views percent',
      render: () => (
        <FormTextField
          slotProps={{
            input: { startAdornment: <InputAdornment position="start">%</InputAdornment> },
          }}
          disabled
          name="extraViewsPercent"
          type="number"
        />
      ),
    },
    {
      title: 'Adform ID',
      render: () => <FormTextField name="adformId" />,
    },
    {
      title: 'Adform client (region)',
      field: 'region',
    },
    {
      title: 'Status',
      render: () => <FormSelect name="status" options={statusOptions} />,
    },
    {
      title: 'Assignee',
      render: () => <FormSelect name="assignedUserId" options={assignableUsersOptions} />,
    },
  ]

  render() {
    const { handleSubmit, loading, onSubmit, initialValues } = this.props

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid
            size={{
              sm: 12,
            }}>
            <DescriptionListTable config={this.getConfig()} data={initialValues} />
          </Grid>
          <Grid
            className="align-right"
            size={{
              sm: 12,
            }}>
            <Button color="secondary" loading={loading} type="submit" variant="contained">
              Update
            </Button>
          </Grid>
        </Grid>
      </form>
    )
  }
}

const EditFormWithDerivedFields = (props: any) => {
  useCampaignDerivedFields()
  return <EditForm {...props} />
}

export default withForm({
  form: FORM_NAME,
  validate: campaignEditValidator,
  warn: campaignChangedCustomerWarnings,
})(EditFormWithDerivedFields)
